module.exports = __webpack_public_path__ + "static/media/M81ws.ee17d53a.pdf";